import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';

// Registering to display currencies and dates in a german format
registerLocaleData(localeDe);

export const MY_FORMATS = {
  parse: {
    dateInput: 'L',
  },
  display: {
    dateInput: 'DD.MM.YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
